@if (unsignedDocument() || unsignedSplittedDocuments().length) {
  <oui-document-viewer
    class="slide-panel-viewer"
    [documentUrl]="fileUrls()"
    [filenames]="filenames()"
    [showControls]="true">
    <div
      class="document-controls"
      oui-document-controls>
      <div>
        <div class="document-name-container">
          <div class="document-name">
            <div class="headline-6">Recueil d'informations</div>
          </div>

          <oui-button
            type="icon"
            color="secondary"
            (click)="closeSlidePanel()">
            <oui-icon>close</oui-icon>
          </oui-button>
        </div>

        <div class="flex-vertical gap-32 top-margin-8">
          <div class="document-date">
            Dernière mise à jour le
            {{
              $safeNavigationMigration(unsignedDocument()?.updatedDate ?? unsignedSplittedDocuments()[0]?.updatedDate)
                | date: 'dd/MM/yyyy à HH:mm'
            }}
          </div>

          @if (isCouple()) {
            <oui-button-toggle
              [options]="recueilTypeOptions"
              [control]="recueilTypeControl">
            </oui-button-toggle>
            <oui-banner
              [title]="
                recueilTypeSignal() === recueilType.couple ? 'Option &quot;Version couple&quot;' : 'Option &quot;Version seule&quot;'
              "
              type="complex"
              [description]="
                recueilTypeSignal() === 'couple'
                  ? 'Activez cette option si vous souhaitez générer un document unique pour les deux membres du couple.\n
                Les deux signatures seront ensuite requises.'
                  : 'Activez cette option si vous souhaitez générer un document distinct pour chaque membre du couple.\n
                  Chaque membre du couple devra signer son propre recueil d\'informations.'
              "
              declination="info"
              [showCloseButton]="false">
            </oui-banner>
          }
          @if (signedDocuments() && signedDocuments().length > 0) {
            <oui-menu [menuItems]="telechargerMenuItems">
              <oui-button
                type="outlined"
                iconSuffix="arrow_drop_down">
                Télécharger le document
              </oui-button>
            </oui-menu>
          } @else {
            <oui-button
              type="outlined"
              (click)="downloadDocument(documentSignedType.unsigned)">
              Télécharger le document
            </oui-button>
          }
          @if (showSendToSignature()) {
            <div
              [ouiTooltip]="signatureTooltip()"
              class="width-fill-available">
              <oui-button
                class="width-fill-available"
                iconPrefix="signature"
                (click)="sendToSignature()"
                [disabled]="signatureDisabled() || isRecueilNotReady()">
                Envoyer en signature
              </oui-button>
            </div>
          }
        </div>
      </div>
    </div>
  </oui-document-viewer>
} @else {
  <div class="loading-container">
    @if (isFetchingDoc()) {
      <oui-loading></oui-loading>
    } @else {
      <oui-etat-vide
        [title]="'Aucun document'"
        icon="unknown_document"></oui-etat-vide>
    }
  </div>
}
